import React from 'react';
import { pdfjs, Document, Page } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.js`;

const options = {
  cMapUrl: `/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: '/standard_fonts/',
};
type Props = {
  url: string;
  width: number;
};

export default function PdfPreview({ url, width }: Props) {
  const [numPages, setNumPages] = React.useState(null);
  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }
  return url ? (
    <Document width={width} file={url} className="nta-pdf__container__document" onLoadSuccess={onDocumentLoadSuccess} options={options}>
      {Array.from(new Array(numPages), (el, index) => (
        <Page width={1190} key={`page_${index + 1}`} pageNumber={index + 1} />
      ))}
    </Document>
  ) : null;
}
